import { Route } from 'react-router-dom';
import { EntityView } from '../common/entityFramework/entityView/EntityView';

const MdRoutes = [
  <Route path="/md/labeler" element={<EntityView />} />,
  <Route path="/md/ndc9-prod" element={<EntityView />} />,
  <Route path="/md/ndc11-prod" element={<EntityView />} />,
  <Route path="/md/med-device-prod" element={<EntityView />} />,
  <Route path="/md/ndc11-prod-low-dispensable-pkg-size" element={<EntityView />} />,
  <Route path="/md/ndc11-prod-unit-threshold" element={<EntityView />} />,
  <Route path="/md/brand-prod" element={<EntityView />} />,
  <Route path="/md/prod-elig" element={<EntityView />} />,
  <Route path="/md/prod-ident" element={<EntityView />} />,
  <Route path="/md/prod-price" element={<EntityView />} />,
  <Route path="/md/prod-rel" element={<EntityView />} />,
  <Route path="/md/cust" element={<EntityView />} />,
  <Route path="/md/cust-addr" element={<EntityView />} />,
  <Route path="/md/cust-ident" element={<EntityView />} />,
  <Route path="/md/cust-info" element={<EntityView />} />,
  <Route path="/md/cust-rel" element={<EntityView />} />,
  <Route path="/md/state" element={<EntityView />} />,
  <Route path="/md/ctrt" element={<EntityView />} />,
  <Route path="/md/mcd-ctrt-predecessor" element={<EntityView />} />,
  <Route path="/md/prog" element={<EntityView />} />,
  <Route path="/md/prog-price" element={<EntityView />} />,
  <Route path="/md/prog-cot-filter" element={<EntityView />} />,
  <Route path="/md/mcd-pharm-exc" element={<EntityView />} />,
  <Route path="/md/cot" element={<EntityView />} />,
  <Route path="/md/mcd-state" element={<EntityView />} />,

]

export default MdRoutes;
